import React from 'react';
import ReportCodes from '../../../components/reports/ReportCodes';
import PageBarReport from '../../components/PageBarReport';

const VerteilungNachSpartenKV = () => {
    return (
        <PageBarReport
            title="Verteilung nach Sparten KV"
            reportCode={ReportCodes.DistributionPerSubSectionsForHealthInsurances}
        />
    );
};

export default VerteilungNachSpartenKV;
